import { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import toast from "react-hot-toast";
import { actualizarCompromiso } from "../../utils/compromisosPago";

// Edita la fecha estimada de pago (compromisos_pago.fecha_estimada) de un compromiso planificado
// SIN plan de cuotas, directamente desde el panel "Movimientos Futuros" (además de la ficha del
// proveedor). Escribe SOLO fecha_estimada — no toca estado ni factura, así que no saca el compromiso
// de la proyección: solo lo reubica en el tiempo. Espejo de ModificarFechaProyeccionCapexModal.
// Los compromisos CON plan editan la fecha de cada cuota dentro del plan (ficha del proveedor).
// Campo obligatorio (10.158) y sin fechas pasadas (es proyección a futuro).

const HOY = new Date().toISOString().split("T")[0];

const normalizarFecha = (fechaStr) => {
  if (!fechaStr) return "";
  return fechaStr.includes("T") ? fechaStr.substring(0, 10) : fechaStr;
};

const formatMonto = (entry) => {
  const n = Math.abs(Number(entry?.importeEnMoneda || 0));
  const num = n.toLocaleString("es-CL", { maximumFractionDigits: 0 });
  const moneda = entry?.moneda_origen === "USD" ? "US$ " : "";
  return `${moneda}${num}`;
};

const ModificarFechaProyeccionCompromisoModal = ({ show, onHide, entry, onSaved }) => {
  const [fecha, setFecha] = useState(normalizarFecha(entry?.fecha_display));
  const [guardando, setGuardando] = useState(false);

  if (!entry) return null;

  const handleGuardar = async () => {
    if (!fecha) {
      toast.error("La fecha es obligatoria");
      return;
    }
    if (fecha < HOY) {
      toast.error("La fecha no puede ser anterior a hoy (es una proyección a futuro).");
      return;
    }
    setGuardando(true);
    try {
      await actualizarCompromiso(entry.compromiso_id, { fecha_estimada: fecha });
      toast.success("Fecha estimada actualizada");
      onSaved?.();
    } catch (e) {
      toast.error(`Error al guardar: ${e.message || e}`);
    } finally {
      setGuardando(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "1.1rem" }}>Modificar fecha estimada de pago</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ fontSize: "0.9rem", lineHeight: 1.7, marginBottom: 16 }}>
          <div>
            <strong>Concepto:</strong> {entry.razon_social_receptor || "—"}
          </div>
          <div>
            <strong>Monto:</strong> {formatMonto(entry)}
          </div>
        </div>

        <Form.Group>
          <Form.Label style={{ fontWeight: 600, fontSize: "0.9rem" }}>Fecha estimada de pago</Form.Label>
          <Form.Control
            type="date"
            value={fecha}
            min={HOY}
            onChange={(e) => setFecha(e.target.value)}
            disabled={guardando}
            style={!fecha ? { borderColor: "#dc3545" } : undefined}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={onHide} disabled={guardando}>
          Cancelar
        </Button>
        <Button variant="primary" size="sm" onClick={handleGuardar} disabled={guardando}>
          {guardando ? "Guardando…" : "Guardar"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModificarFechaProyeccionCompromisoModal;
